<template>
  <div class="create-analyzer-sources">
    <div class="header">
      <h2>Model Summary</h2>
    </div>

    <div class="options">
      <div :class="['card']">
        <h3>Summary</h3>
        <p>Model Type: <span>{{ analyzer.analyzerType ? analyzer.analyzerType.toUpperCase() : '' }}</span></p>
        <p>Total tokens: {{ totalTokens }}</p>
        <p class="cost">
          <span>Cost: </span>
          <img src="/static/emerald.png" alt="" height="20">
          <span v-if="loadingCost" class="loading-cost">-</span>
          <span v-else :style="{ color: credits >= cost ? 'green' : 'red' }">{{ cost }} <span style="color:grey">({{ credits }})</span></span>
        </p>
        <p>
          <span>Name:</span>
          <input v-model="name" type="text" name="model-name" id="model-name" @input="changeName">
        </p>
      </div>
    </div>


    <div class="next">
      <button class="empty" @click="$router.push('/models/create/models_sources')">Back</button>
      <button :disabled="!canContinue" @click="next">Build Model</button>
    </div>
  </div>
</template>

<script>


import { getCredits } from '@/api';
import config from '../../config';

export default {
  name: 'AnalyzerSummary',
  props: {
    analyzer: Object
  },
  data () {
    return {
      name: '',
      loadingCost: true,
      cost: 0,
      credits: 0
    }
  },
  methods: {
    next () {
      this.$router.push('/models/create/models_build');
    },
    changeName () {
      this.$emit('update', {
        name: this.name
      });
    },
    getCost () {
      const token = localStorage.getItem('token');

      const body = {
        name: this.analyzer.name,
        analyzer_type: this.analyzer.analyzerType,
        data_sources: {
          documents: this.analyzer.dataSources.documents.map(document => ({
            id: document.id,
            name: document.name,
            content: document.content,
            type: document.type,
            tokens_amount: document.tokens,
          })),
          websites: this.analyzer.dataSources.websites.map(website => ({
            id: website.id,
            visited_links: website.visitedLinks,
            tokens_amount: website.tokens,
            url: website.url,
            follow_external: website.followExternal,
            follow_internal: website.followInternal
          })),
          plain_text: this.analyzer.dataSources.plainText,
        }
      }
      
      fetch(config.api + '/models/cost', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(body)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.json();
      })
      .then(cost => {
        this.cost = cost;
        this.loadingCost = false;
      })
      .catch(() => {
        this.notificationController.addNotification({ type: 'error', title: 'Internal error', message: 'Could not load cost. Please try again later.', duration: 3000 });
      });
    },
    getCredits() {
      getCredits()
          .then(credits => {
              this.credits = credits;
              this.getCost();
          })
          .catch(() => {
              this.notificationController.addNotification({ type: 'error', title: 'Internal error', message: 'Could not load credits.', duration: 3000 });
          });
    },
  },
  computed: {
    canContinue () {
      return this.name.length > 3 && this.name.length < 50 && !this.loadingCost
    },
    totalTokens () {
      return this.analyzer.dataSources.documents.reduce((acc, doc) => acc + doc.tokens, 0) +
        this.analyzer.dataSources.websites.reduce((acc, website) => acc + website.tokens, 0)
    }
  },
  created () {
    this.name = this.analyzer.name;

    this.getCredits();
  }
}
</script>

<style scoped>

input {
  width: 90%;
  padding: 2px 10px;
}

p.cost {
  display: flex;
  align-items: center;
}

.loading-cost {
  font-weight: 700;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/CreateModelFlow/AnalyzerSummary.vue